import { HubConnection, HubConnectionBuilder, LogLevel, HttpError } from '@microsoft/signalr';
import moment from 'moment';
import { Version } from 'version-parser';
import { loadv1, screenshotV1 } from '../v1/main'
import { loadv2, screenshotV2 } from '../v2/main'
import interact from 'interactjs';

declare global {
    interface String {
        render(context: any): string;
    }
}
enum ApiUrlType {
    JsonFile,
    Live2dWeb,
    Other
}

export class Live2dTips {
    private readonly _live2dwebAPI = "https://api.live2dweb.com";
    private readonly _lwcSignalR = "https://api.live2dweb.com";
    private readonly _localModelPath: string;
    private readonly _live2dSettings: any;
    private readonly _userToken: any;
    private readonly _live2dTips: any;
    private readonly _currentPage:any;
    private readonly _unitType = 'px';
    private readonly _regMod3Json = new RegExp("(\.json)$", "gi");
    private readonly _regApiUrl = new RegExp(`${this._live2dwebAPI}/[^\s]*(\/v2)`, "i");
    /** 定义highlight标记 */
    private hltips = 'color:';
    private _tipsIsShow: boolean;
    private _getActed: boolean = false;
    private hitokotoTimer: NodeJS.Timeout | undefined;
    private hitokotoInterval: boolean = false;
    private connection: HubConnection | undefined;
    private _gptMsg: string = '';
    //以下是live2d元素的声明
    private waifuDiv: HTMLDivElement;
    private tipsDiv: HTMLDivElement;
    private live2dCanvas: HTMLCanvasElement;
    private toolDiv: HTMLDivElement;
    private btnHome: HTMLSpanElement;
    private btnChat: HTMLSpanElement;
    private btnBot: HTMLSpanElement;
    private btnEye: HTMLSpanElement;
    private btnUser: HTMLSpanElement;
    private btnPhoto: HTMLSpanElement;
    private btnInfoCircle: HTMLSpanElement;
    private btnCross: HTMLSpanElement;
    private inputGroup: HTMLDivElement;
    private txtChat: HTMLInputElement;
    private btnSend: HTMLButtonElement;
    private tipsTimeout: NodeJS.Timeout;
    private ver: Version;
    private chatServiceConn: boolean;
    private docNowWidth: number;

    constructor(settings: any) {
        this._live2dSettings = settings.settings;
        this._userToken = settings.userInfo;
        this._live2dTips = settings.waifuTips;
        this._localModelPath = settings.localPath;
        this._currentPage = settings.currentPage;
        this._tipsIsShow = false;
        this.waifuDiv = document.querySelector(".waifu");
        this.tipsDiv = document.querySelector(".waifu-tips");
        this.live2dCanvas = document.querySelector("#live2d");
        this.toolDiv = document.querySelector(".waifu-tool");
        this.btnHome = document.querySelector(".waifu-tool .fui-home");
        this.btnChat = document.querySelector(".waifu-tool .fui-chat");
        this.btnBot = document.querySelector(".waifu-tool .fui-bot");
        this.btnEye = document.querySelector(".waifu-tool .fui-eye");
        this.btnUser = document.querySelector(".waifu-tool .fui-user");
        this.btnPhoto = document.querySelector(".waifu-tool .fui-photo");
        this.btnInfoCircle = document.querySelector(".waifu-tool .fui-info-circle");
        this.btnCross = document.querySelector(".waifu-tool .fui-cross");
        this.inputGroup = document.querySelector(".waifu .gptInput");
        this.txtChat = document.querySelector("#live2dChatText");
        this.btnSend = document.querySelector("#live2dSend");
        this.chatServiceConn = false;
        this.docNowWidth = window.innerWidth;
    }

    public initTips() {
        const that = this;
        this.tipsDiv.style.width = this._live2dSettings.waifuTipsSize['width'] + this._unitType;  //宽度
        this.tipsDiv.style.minHeight = this._live2dSettings.waifuTipsSize['height'] + this._unitType;//高度
        this.tipsDiv.style.top = (0 - this._live2dSettings.waifuTipTop) + this._unitType;//上方位置可以是负数
        this.tipsDiv.style.fontSize = this._live2dSettings.waifuFontSize + this._unitType; //字号
        this.tipsDiv.style.border = "1px solid " + this._live2dSettings.waifuBorderColor;//边框颜色 固定值是1px实心线条
        this.tipsDiv.style.backgroundColor = this._live2dSettings.waifuTipsColor;//背景色
        this.tipsDiv.style.boxShadow = "0 3px 15px 2px " + this._live2dSettings.waifuShadowColor;//影子的颜色 有4个位置默认值
        this.tipsDiv.style.color = this._live2dSettings.waifuFontsColor; //字体颜色

        const toolSpan = document.querySelectorAll('.waifu-tool span');
        toolSpan.forEach((span: HTMLSpanElement) => {
            span.addEventListener("mouseover", function () {
                span.style.color = that._live2dSettings.waifuToolHover;
            });

            span.addEventListener("mouseout", function () {
                span.style.color = that._live2dSettings.waifuToolColor;
            });

            span.style.color = that._live2dSettings.waifuToolColor;
            span.style.lineHeight = that._live2dSettings.waifuToolLine + this._unitType;
        });
        //--------------只是分割线而已-------------
        this.toolDiv.style.fontSize = this._live2dSettings.waifuToolFont + this._unitType;
        this.toolDiv.style.top = this._live2dSettings.waifuToolTop + this._unitType;

        this.hltips += this._live2dSettings.waifuHighlightColor + ';';//定义highlight标记并赋值，因为是一个css所以必须;结尾

        if (this._live2dSettings.waifuEdgeSide === 'left') {
            this.waifuDiv.style.left = this._live2dSettings.waifuEdgeSize + this._unitType;
        } else if (this._live2dSettings.waifuEdgeSide === 'right') {
            //this.waifuDiv.style.left = (that.docNowWidth - (Number(that._live2dSettings.waifuSize.width) + that._live2dSettings.waifuEdgeSize)) + that._unitType;
            this.waifuDiv.style.right = this._live2dSettings.waifuEdgeSize + this._unitType;
        }
        const minWidth = Number(this._live2dSettings.waifuMinWidth);
        if (minWidth != 0) {
            if (window.innerWidth <= minWidth) {
                this.waifuDiv.style.display = "none";
                return;
            } else {
                this.waifuDiv.style.display = "block";
            }
        }
        window.addEventListener("resize", function () {
            that.waifuResize();
        });

        interact(that.waifuDiv).draggable({
            // enable inertial throwing
            inertia: true,
            // keep the element within the area of it's parent
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: 'window',
                    endOnly: true
                })
            ],
            listeners: {
                // call this function on every dragmove event
                move: dragMoveListener,
                //松开鼠标的时候
                end(event) {
                    const target = event.target;
                    if (that._live2dSettings.waifuDraggableRevert) {
                        // translate the element
                        target.style.transform = `translate(0, 0)`;
                        target.style.transition = 'all .3s ease-in-out';
                        target.setAttribute('data-x', 0);
                        target.setAttribute('data-y', 0);
                    }
                }
            }
        });

        function dragMoveListener(event: any) {
            const target = event.target;
            target.style.transition = 'none';
            // keep the dragged position in the data-x/data-y attributes
            const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
            const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            switch (that._live2dSettings.waifuDraggable) {
                case 'axis-x':
                    // translate the element
                    target.style.transform = `translate(${x + that._unitType}, 0)`;

                    // update the posiion attributes
                    target.setAttribute('data-x', x);
                    break;
                case 'unlimited':
                    // translate the element
                    target.style.transform = `translate(${x + that._unitType}, ${y + that._unitType})`;

                    // update the posiion attributes
                    target.setAttribute('data-x', x);
                    target.setAttribute('data-y', y);
                    break;
                default:
                    // translate the element
                    target.style.transform = `translate(0, 0)`;

                    // update the posiion attributes
                    target.setAttribute('data-x', 0);
                    target.setAttribute('data-y', 0);
                    break;
            }
        }

        this.btnHome.addEventListener("click", () => {
            window.location = that._live2dSettings.homePageUrl;
        });

        this.btnInfoCircle.addEventListener("click", () => {
            window.open(that._live2dSettings.aboutPageUrl);
        });

        this.loadTipsMessage(this._live2dTips);
        this.showWelcomeMessage(this._live2dTips);

        if (!this._live2dSettings.showToolMenu) this.toolDiv.style.display = 'none';
        if (!this._live2dSettings.canCloseLive2d) this.btnCross.style.display = 'none';
        if (!this._live2dSettings.canSwitchModel) this.btnEye.style.display = 'none';
        if (!this._live2dSettings.canSwitchTextures) this.btnUser.style.display = 'none';
        if (!this._live2dSettings.canSwitchHitokoto) this.btnChat.style.display = 'none';
        if (!this._live2dSettings.canTakeScreenshot) this.btnPhoto.style.display = 'none';
        if (!this._live2dSettings.canTurnToHomePage) this.btnHome.style.display = 'none';
        if (!this._live2dSettings.canTurnToAboutPage) this.btnInfoCircle.style.display = 'none';
        if (!this._live2dSettings.isBotButton) this.btnBot.style.display = 'none';

        this.btnEye.addEventListener("click", () => { that.loadOtherModel() });
        this.btnUser.addEventListener("click", () => { that.loadRandTextures() });
        this.btnChat.addEventListener("click", () => { that.doShowHitokoto() });
        this.btnBot.addEventListener("click", () => that.chatGpt());

        if (this._live2dSettings.showHitokoto) {
            document.addEventListener("mousemove", (e) => {
                this._getActed = true;
            });
            document.addEventListener("keydown", (e) => {
                this._getActed = true;
            });
            //每秒检测活跃状态
            setInterval(() => {
                /** 
                 * 如果不活跃则进入待机状态
                 * 默认为活跃, 会进入elseActed 
                 * 进入后直接变为不活跃
                 * */
                if (!this._getActed)
                    this.ifActed();
                else
                    this.elseActed();
            }, 1000);
        }
    }

    private ifActed() {
        if (!this.hitokotoInterval) {
            this.hitokotoInterval = true;
            this.hitokotoTimer = setInterval(async () => { await this.showHitokotoActed(); }, 30000);
        }
    }

    private elseActed() {
        this._getActed = this.hitokotoInterval = false;
        clearInterval(this.hitokotoTimer);
    }

    private async showHitokotoActed() {
        if (document.visibilityState == 'visible') {
            this.doShowHitokoto();
        }
        if (this.connection && this.connection.state == 'Connected') {
            this.chatServiceConn = false;
            await this.connection.stop();
            this.hideChatControl();
        }
    }

    protected async doShowHitokoto() {
        const that = this;
        let result: any;
        switch (this._live2dSettings.hitokotoAPI) {
            case 'fghrsh.net':
                result = await fetch('https://api.fghrsh.net/hitokoto/rand/?encode=jsc&uid=3335', { method: 'GET' }).then(rsp => rsp.json());
                if (result.source) {
                    var text = "";
                    that._live2dTips.hitokoto_api_message.forEach((val: Array<any>) => {
                        if (val[0] === 'fghrsh.net') {
                            text = val[1];
                        }
                    });
                    text = text.render({ source: result.source, date: result.date, highlight: that.hltips });
                    window.setTimeout(function () { that.showMessage(text, 3000); }, 5000);
                    that.showMessage(result.hitokoto, 5000);
                }
                break;
            case 'jinrishici.com':
                result = await fetch('https://v2.jinrishici.com/one.json', { method: 'GET' }).then(rsp => rsp.json());
                if (result.data.origin.title) {
                    var text = "";
                    that._live2dTips.hitokoto_api_message.forEach((val: Array<any>) => {
                        if (val[0] === 'jinrishici.com') {
                            text = val[1];
                        }
                    });
                    text = text.render({ title: result.data.origin.title, dynasty: result.data.origin.dynasty, author: result.data.origin.author, highlight: that.hltips });
                    window.setTimeout(function () { that.showMessage(text, 3000); }, 5000);
                    that.showMessage(result.data.content, 5000);
                }
                break;
            default:
                result = await fetch('https://v1.hitokoto.cn', { method: 'GET' }).then(rsp => rsp.json());
                if (result.from) {
                    var text = "";
                    that._live2dTips.hitokoto_api_message.forEach((val: Array<any>) => {
                        if (val[0] === 'hitokoto.cn') {
                            text = val[1];
                        }
                    });
                    text = text.render({ source: result.from, creator: result.creator, highlight: that.hltips });
                    window.setTimeout(function () { that.showMessage(text, 3000); }, 5000);
                    that.showMessage(result.hitokoto, 5000);
                }
        }
    }

    protected hideChatControl() {
        this.inputGroup.classList.remove("show");
        this.btnSend.removeEventListener("click", this.sendMsg.bind(this));
    }

    private convertUrl(apiUrl: string) {
        let apiLen = apiUrl.length - 1;
        let lidx = apiUrl.lastIndexOf('/');
        if (apiLen == lidx)
            apiUrl = apiUrl.substring(0, lidx);
        return apiUrl;
    }

    private convertApiUrl(apiUrl: string): ApiUrlType {
        if (!this._regMod3Json.test(apiUrl)) {
            //这不是MOC3模型
            if (this._regApiUrl.test(apiUrl)) {
                //如果API是我的地址
                return ApiUrlType.Live2dWeb;
            } else {
                //这是PHP的那种URL
                return ApiUrlType.Other;
            }
        } else {
            return ApiUrlType.JsonFile;
        }
    }

    private async chatGpt() {
        if (typeof this._userToken === 'undefined') {
            this.showMessage("想和我说点什么？记得插件需要先登录哦~", 5000);
            return;
        }
        const sign = this._userToken.sign;
        this.showMessage("想和我说点什么？", 5000);
        this.connection = new HubConnectionBuilder()
            .withUrl(`${this._lwcSignalR}/chatmsg`, { accessTokenFactory: () => sign })
            .configureLogging(LogLevel.Debug)
            .build();
        if (this.connection.state != "Connected" && !this.chatServiceConn) {
            this.chatServiceConn = true;
            await this.connection.start().catch((err) => {
                if (err instanceof HttpError) {
                    switch (err.statusCode) {
                        case 403:
                        case 401:
                            this.chatServiceConn = false;
                            console.warn("您没有权限访问这个接口");
                            break;
                        case 500:
                            this.chatServiceConn = false;
                            console.error("服务异常,正在重新连接", err);
                            setTimeout(
                                async () => {
                                    await this.chatGpt()
                                }
                                , 5000);
                            break;
                    }
                }
            });
            console.log("服务器已连接.");
            this.showChatControl();
            this.connection.on("reply", (text) => {
                this._gptMsg += text;
                this.txtChat.value = "";
                this.showMessage(this._gptMsg, 5000);
            });
        } else {
            console.log("服务器已连接, 请勿重新连接");
        }
    }

    private showChatControl() {
        this.inputGroup.classList.add("show");
        this.btnSend.addEventListener("click", this.sendMsg.bind(this));
        this.txtChat.addEventListener("keyup", (e) => {
            if (e.key === 'Enter') {
                this.sendMsg();
            }
        });
    }
    private async sendMsg() {
        if (this.connection.state != "Connected") {
            await this.connection.start();
        }
        this._gptMsg = "";
        try {
            await this.connection.invoke("Conversation", this.txtChat.value, this._currentPage);
        } catch (err) {
            console.error(err);
        }
    }

    public async initModel(modelId: number | string, modelTexturesId: number | string) {
        if (!this._userToken?.sign) {
            console.warn("需要与插件官网链接后才可以使用, 请先登录, 或访问https://www.live2dweb.com/ 了解更多");
            return;
        }
        modelId = sessionStorage.getItem("modelId") ?? modelId;
        modelTexturesId = sessionStorage.getItem("modelTexturesId") ?? modelTexturesId;
        let settings = Object.assign({}, this._live2dSettings);
        settings.userInfo = this._userToken;
        /* 加载Live2D容器样式 */
        this.live2dCanvas.setAttribute("width", settings.waifuSize.width.toString());
        this.live2dCanvas.setAttribute("height", settings.waifuSize.height.toString());
        /** 获取文件清单 */
        let result: any;
        let apiUrl = this.convertUrl(settings.modelAPI);
        const apiType = this.convertApiUrl(apiUrl);
        switch (apiType) {
            case ApiUrlType.JsonFile:
                apiUrl = settings.modelAPI;
                break;
            case ApiUrlType.Live2dWeb:
                if (this._live2dSettings.apiType) {
                    apiUrl = `${apiUrl}?id=${modelId}&tid=${modelTexturesId}&apiUrl=${encodeURIComponent(this._localModelPath)}`;
                } else {
                    apiUrl = `${apiUrl}?id=${modelId}&tid=${modelTexturesId}`;
                }
                break;
            case ApiUrlType.Other:
                apiUrl = `${apiUrl}/get/?id=${modelId}-${modelTexturesId}`;
                break;
        }
        if (apiType === ApiUrlType.Live2dWeb) {
            const response = fetch(apiUrl, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${this._userToken.sign}`
                },
                cache: 'default'
            });
            if ((await response).status !== 200) {
                console.warn("当前站点没有使用正确的授权。");
                return;
            } else {
                result = await response.then(rsp => rsp.json());
            }
        } else {
            result = await fetch(apiUrl, {
                method: "GET",
                cache: 'default'
            }).then(rsp => rsp.json());
        }
        if (!result) {
            console.warn("模型切换失败。");
            return;
        } 
        /*else if (!result.textures) {
            console.warn("这个模型不存在");
            return;
        } else if (result.textures.length == 0) {
            console.warn("这个模型读取服务器时出现错误：", result.BodyMessage.Msg, result.BodyMessage.ErrorCode);
            return;
        }*/

        if (typeof result.Version === "number") {
            this.ver = new Version(`${result.Version}.0.0`);
        } else {
            this.ver = new Version(result.version || result.Version || "1.0.0");
        }

        if (this.ver.get_major_version() === 1) {
            loadv1('live2d', apiUrl, settings, result);
        } else {
            loadv2('live2d', settings, result);
        }
    }

    public showMessage(text: string | string[], timeout: number = 5000) {
        let theText = this.getRandText(text);
        const that = this;
        this.tipsDiv.innerHTML = theText;
        that._tipsIsShow = this.tipsDiv.classList.contains('show');
        if (!that._tipsIsShow) {
            this.tipsDiv.classList.add("show");
        }
        that.hideMessage(timeout);
    }

    public hideMessage(timeout: number = 5000) {
        const that = this;
        clearTimeout(that.tipsTimeout);
        that.tipsTimeout = setTimeout(() => {
            that.tipsDiv.classList.remove("show");
            that._tipsIsShow = false;
        }, timeout);
    }

    private loadTipsMessage(result: any) {
        const that = this;
        result.mouseover_msg.forEach((val: any, index: number) => {
            const msgAnySelect = document.querySelector(val.selector) as HTMLElement;
            if (msgAnySelect) {
                msgAnySelect.addEventListener('mouseover', () => {
                    var text = that.getRandText(val.text);
                    text = text.render({ text: msgAnySelect.textContent, highlight: that.hltips });
                    that.showMessage(text, 3000);
                })
            }
        });

        const click_selector = document.querySelector(result.click_selector) as HTMLElement;
        click_selector.addEventListener('click', () => {
            var text = that.getRandText(result.click_msg);
            text = text.render({ text: click_selector.textContent, highlight: that.hltips });
            that.showMessage(text, 3000);
        });

        result.seasons_msg.forEach((val: any, index: number) => {
            const now = moment();
            const after = moment(val[0].split('-')[0], 'MM/DD').startOf('day');
            const before = moment(val[0].split('-')[1] || after, 'MM/DD').endOf('day');
            if (now.isBetween(after, before)) {
                var text = that.getRandText(val[1]);
                text = text.render({ year: now.format('YYYY'), highlight: that.hltips });
                that.showMessage(text, 6000);
            }
        });

        if (this._live2dSettings.showCopyMessage) {
            document.addEventListener('copy', () => {
                that.showMessage(that.getRandText(result.copy_message), 5000);
            });
        }
        this.btnPhoto.addEventListener("click", () => {
            that.showMessage(that.getRandText(result.screenshot_message), 5000);
            if (that.ver.get_major_version() === 1) {
                screenshotV1(that._live2dSettings.screenshotCaptureName, true);
            } else {
                screenshotV2(that._live2dSettings.screenshotCaptureName, true);
            }

        })

        this.btnCross.addEventListener("click", () => {
            that.showMessage(that.getRandText(result.hidden_message), 1300);
            window.setTimeout(function () {
                that.waifuDiv.style.display = 'none';
            }, 1300);
        });
    }

    private getRandText(text: string | string[]): string {
        if (Array.isArray(text)) {
            return text[Math.floor(Math.random() * text.length + 1) - 1];
        } else {
            return text;
        }
    }

    private waifuResize() {
        const minWidth: number = this._live2dSettings.waifuMinWidth;
        if (window.innerWidth <= minWidth) {
            this.waifuDiv.style.display = "none";
        } else {
            this.waifuDiv.style.display = "block";
        }
        this.docNowWidth = window.innerWidth;
        if (this._live2dSettings.waifuEdgeSide == 'right') {
            this.waifuDiv.style.left = (this.docNowWidth - (Number(this._live2dSettings.waifuSize.width) + this._live2dSettings.waifuEdgeSize)) + this._unitType;
        }
    }
    private showWelcomeMessage(result: any) {
        var text: string;
        if (window.location.href == this._live2dSettings.homePageUrl) {
            var now = (new Date()).getHours();
            if (now > 23 || now <= 5) text = this.getRandText(result.hour_tips['t23-5']);
            else if (now > 5 && now <= 7) text = this.getRandText(result.hour_tips['t5-7']);
            else if (now > 7 && now <= 11) text = this.getRandText(result.hour_tips['t7-11']);
            else if (now > 11 && now <= 14) text = this.getRandText(result.hour_tips['t11-14']);
            else if (now > 14 && now <= 17) text = this.getRandText(result.hour_tips['t14-17']);
            else if (now > 17 && now <= 19) text = this.getRandText(result.hour_tips['t17-19']);
            else if (now > 19 && now <= 21) text = this.getRandText(result.hour_tips['t19-21']);
            else if (now > 21 && now <= 23) text = this.getRandText(result.hour_tips['t21-23']);
            else text = this.getRandText(result.hour_tips['default']);
        } else {
            const referrer_message: Array<any> = result.referrer_message;
            // 用来隔开网站标题中的 “-” 
            const titleStr = document.title.split(' – ')[0];
            // 在document.referrer不为空的时候执行
            if (document.referrer !== '') {
                try {
                    var referrer = document.createElement('a');
                    referrer.href = document.referrer;
                    if (window.location.hostname == referrer.hostname) {
                        //如果是本站点跳转
                        const match = referrer_message.find(([key, value]) => key === "localhost");
                        text = match[1];
                    } else {
                        //外部站点跳转至此
                        const domain = referrer.hostname.split('.')[1];
                        const match = referrer_message.find(([key, value]) => key === domain);
                        if (match) {
                            text = match[1];
                        } else {
                            text = referrer_message.find(([key, value]) => key === "default")[1];
                        }
                    }
                    text = text.render({ title: titleStr, highlight: this.hltips });
                } catch (err) {
                    console.log('It is not important Exception ' + err)
                }
            } else {
                const match = referrer_message.find(([key, value]) => key === "none");
                text = match[1];
                text = text.render({ title: titleStr, highlight: this.hltips });
            }
        }
        this.showMessage(text, 6000);
    }

    private loadOtherModel() {
        const that = this;
        let settings = Object.assign({}, this._live2dSettings);
        const modelId = sessionStorage.getItem("modelId") ?? settings.modelId;
        let apiUrl = this.convertUrl(settings.modelAPI);
        switch (this.convertApiUrl(apiUrl)) {
            case ApiUrlType.JsonFile:
                console.log("直接指向JSON文件不支持换装");
                break;
            case ApiUrlType.Live2dWeb:
                apiUrl = `${apiUrl}/NextModel/?id=${modelId}&type=${settings.modelRandMode == 'rand' ? 0 : 1}&isWorkshop=${settings.apiType}`;
                fetch(apiUrl, {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${that._userToken.sign}`
                    }
                }).then(rsp => rsp.json())
                    .then(result => {
                        that.initModel(result.ModelId, result.TextureId);
                        that.showMessage(result.Message, 3000);
                        sessionStorage.setItem("modelId", `${result.ModelId}`);
                        sessionStorage.setItem("modelTexturesId", `${result.TextureId}`);
                    }).catch(error => {
                        console.log("认证失败", error);
                    });
                break;
            case ApiUrlType.Other:
                apiUrl = `${apiUrl}/${settings.modelRandMode}/?id=${modelId}`;
                fetch(apiUrl, {
                    method: "GET",
                }).then(rsp => rsp.json())
                    .then(result => {
                        that.initModel(result.model['id'], 0);
                        that.showMessage(result.model['message'], 3000);
                        sessionStorage.setItem("modelId", `${result.model['id']}`);
                        sessionStorage.setItem("modelTexturesId", `0`);
                    }).catch(error => {
                        console.log("获取失败", error);
                    });
                break;
        }
    }

    private loadRandTextures() {
        const that = this;
        let settings = Object.assign({}, this._live2dSettings);
        const modelId = sessionStorage.getItem("modelId") ?? settings.modelId;
        const texturesId = sessionStorage.getItem("modelTexturesId") ?? settings.modelTexturesId;
        let apiUrl = this.convertUrl(settings.modelAPI);
        switch (this.convertApiUrl(apiUrl)) {
            case ApiUrlType.JsonFile:
                console.log("直接指向JSON文件不支持换装");
                break;
            case ApiUrlType.Live2dWeb:
                apiUrl = `${apiUrl}/NextModel/?id=${modelId}&tid=${texturesId}&type=${settings.modelRandMode == 'rand' ? 2 : 3}&isWorkshop=${settings.apiType}`;
                fetch(apiUrl, {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${that._userToken.sign}`
                    }
                }).then(rsp => rsp.json())
                    .then(result => {
                        if (result.TextureId !== texturesId) {
                            that.showMessage(that._live2dTips.load_rand_textures[1]);
                        } else {
                            that.showMessage(that._live2dTips.load_rand_textures[0]);
                        }
                        that.initModel(result.ModelId, result.TextureId);
                        sessionStorage.setItem("modelId", `${modelId}`);
                        sessionStorage.setItem("modelTexturesId", `${result.TextureId}`);
                    }).catch(error => {
                        console.log("认证失败", error);
                    });
                break;
            case ApiUrlType.Other:
                apiUrl = `${apiUrl}/${settings.modelRandMode}_textures/?id=${modelId}-${texturesId}`;
                fetch(apiUrl, {
                    method: "GET",
                }).then(rsp => rsp.json())
                    .then(result => {
                        if (result.textures['id'] !== texturesId) {
                            that.showMessage(that._live2dTips.load_rand_textures[1]);
                        }
                        else {
                            that.showMessage(that._live2dTips.load_rand_textures[0]);
                        }
                        that.initModel(modelId, result.textures['id']);
                        sessionStorage.setItem("modelId", `${modelId}`);
                        sessionStorage.setItem("modelTexturesId", `${result.textures['id']}`);
                    }).catch(error => {
                        console.log("获取失败", error);
                    });
                break;
        }
    }
}

String.prototype.render = function (context: any): string {
    const tokenReg = /(\\)?\{([^\{\}\\]+)(\\)?\}/g;

    return this.replace(tokenReg, function (word, slash1, token, slash2) {
        if (slash1 || slash2) { return word.replace('\\', ''); }

        const variables = token.replace(/\s/g, '').split('.');
        let currentObject = context;
        let i, length, variable;

        for (i = 0, length = variables.length; i < length; ++i) {
            variable = variables[i];
            currentObject = currentObject[variable];
            if (!currentObject) return '';
        }
        return currentObject;
    });
};